/**
 * Router
 *
 * This class was adapted from onedesign/one-router:
 * @link https://github.com/onedesign/one-router
 */
export default class Router {
    /**
     * Initializes the router with a set of rules. Rules cannot be added later, except by manual assignment:
     *
     * ```js
     * const router = new Router({
     *   '^/commerce': function(path) {}
     * });
     *
     * router.routes['^/commerce/in-the-wild'] = function(path) {
     *   // ...
     * };
     * ```
     *
     * @param {Object} routes Pass a map of keys (URIs, paths, or regular expressions) and values (functions or an array of functions).
     */
    constructor(routes) {
        this.routes = routes;
    }

    /**
     * Invoke this method each time the route changes. The provided path is tested against each rule, and for those that match, each handler is run in sequence.
     *
     * @param {String} path
     */
    handle(path) {
        // Run through each route until we find a match:
        for (let pattern in this.routes) {
            let handlers = this.routes[pattern];

            if (!this.match(pattern, path)) {
                continue;
            }

            // Convert all routes to an array of handlers:
            if (typeof handlers === 'function') {
                handlers = [handlers];
            }

            handlers.forEach(function(h) {
                // Invoke the handler, passing in the real/matched path:
                h.call(path);
            });
        }
    }

    /**
     * Evaluate a route/pattern expression against the provided path.
     *
     * @param {String} pattern
     * @param {String} path
     * @returns {Boolean}
     */
    match(pattern, path) {
        return (new RegExp(pattern, 'i')).test(path);
    }
}
